var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0856 8.53105C13.8269 8.20761 13.3549 8.15516 13.0315 8.41392L11.75 9.43908V5.99957C11.75 5.58536 11.4142 5.24957 11 5.24957C10.5858 5.24957 10.25 5.58536 10.25 5.99957V9.43913L8.96849 8.41392C8.64505 8.15517 8.17308 8.20761 7.91432 8.53105C7.65556 8.8545 7.708 9.32647 8.03145 9.58523L10.5287 11.5831C10.6575 11.6872 10.8215 11.7496 11 11.7496C11.1801 11.7496 11.3453 11.6861 11.4746 11.5804L13.9685 9.58523C14.2919 9.32647 14.3444 8.8545 14.0856 8.53105Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46038 3.28344C8.40301 1.82691 10.0427 0.861328 11.9091 0.861328C14.7228 0.861328 17.024 3.05583 17.1944 5.82665C17.2506 5.82451 17.307 5.82343 17.3636 5.82343C19.7862 5.82343 21.75 7.78727 21.75 10.2098C21.75 12.6323 19.7862 14.5962 17.3636 14.5962L6 14.5962C2.82436 14.5962 0.25 12.0218 0.25 8.84616C0.25 5.67052 2.82436 3.09616 6 3.09616C6.50391 3.09616 6.99348 3.16115 7.46038 3.28344ZM11.9091 2.36133C10.404 2.36133 9.1021 3.23731 8.48806 4.51059C8.31801 4.8632 7.90536 5.02571 7.54054 4.88375C7.0639 4.69828 6.54477 4.59616 6 4.59616C3.65279 4.59616 1.75 6.49895 1.75 8.84616C1.75 11.1934 3.65279 13.0962 6 13.0962L17.3627 13.0962C18.9568 13.0962 20.25 11.8039 20.25 10.2098C20.25 8.6157 18.9577 7.32343 17.3636 7.32343C17.1042 7.32343 16.8539 7.35747 16.6164 7.4209C16.3762 7.48506 16.1198 7.426 15.9319 7.26323C15.7439 7.10046 15.6489 6.85513 15.6781 6.60822C15.6955 6.46046 15.7045 6.30984 15.7045 6.15678C15.7045 4.06061 14.0053 2.36133 11.9091 2.36133Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.1fe79cdc8213d0608b82dce471502f9c.svg";
export { ForwardRef as ReactComponent };